import { reduce, size } from 'lodash';

import { useToggler } from 'hooks';

interface Input<T> {
    initSize: number;
    items: T[];
    cellInRow: number;
}

interface Output<T> {
    canCollapse: boolean;
    moreCount: number;
    visibleItems: T[];
    extraItems: T[];
    toggleIsCollapsed: VoidFunction;
    isCollapsed: boolean;
    visibleStubsSize: number;
    extraStubsSize: number;
    validCellInRow: number;
}

export default function useLessMoreContainer<T>({
    initSize,
    items,
    cellInRow,
}: Input<T>): Output<T> {
    const validCellInRow = items.length < cellInRow ? items.length : cellInRow;
    const validInitSize = initSize + getLackSize(initSize, validCellInRow);

    const allSize = size(items);

    const canCollapse = allSize > validInitSize;

    const [isCollapsed, toggleIsCollapsed] = useToggler(canCollapse);

    const [visibleItems, extraItems] = reduce(
        items,
        (acc: [T[], T[]], item, idx) => {
            acc[idx < validInitSize ? 0 : 1].push(item);

            return acc;
        },
        [[], []]
    );

    const moreCount = extraItems.length;

    const visibleStubsSize = getLackSize(visibleItems.length, validCellInRow);
    const extraStubsSize = getLackSize(extraItems.length, validCellInRow);

    return {
        canCollapse,
        moreCount,
        visibleItems,
        extraItems,
        isCollapsed,
        toggleIsCollapsed,
        visibleStubsSize,
        extraStubsSize,
        validCellInRow,
    };
}

function getLackSize(itemsSize: number, cellInRow: number): number {
    const remainder = itemsSize % cellInRow;

    return remainder ? cellInRow - remainder : 0;
}
